import React, { useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import { useCalendarNavigation } from "../hooks/use_calendar_navigation";
import { IconButton } from "../components/icon_button";
import classNames from "classnames";

// Wrapped version of DayPicker with an nav bar with year change buttons
export const DayPickerCalendar = ({
  defaultMonth = new Date(),
  className = "em-date-picker",
  ...props
}) => {
  const {
    currentMonth,
    goToPreviousYear,
    goToNextYear,
    goToPreviousMonth,
    goToNextMonth,
    handleMonthChange,
  } = useCalendarNavigation(defaultMonth);

  const currentMonthString = useMemo(() => {
    return moment(currentMonth).format("MMMM yyyy");
  }, [currentMonth]);

  const navClass = `${className}--nav`;
  const navTitleClass = `${className}--nav-title`;
  const navButtonClass = `${className}--nav-button`;

  return (
    <div className={className}>
      <div className={navClass}>
        <IconButton
          label="Go to previous year"
          icon="angles-left"
          onClick={goToPreviousYear}
          className={navButtonClass}
        />
        <IconButton
          label="Go to previous month"
          icon="angle-left"
          onClick={goToPreviousMonth}
          className={navButtonClass}
        />
        <p aria-live="polite" className={navTitleClass}>
          {currentMonthString}
        </p>
        <IconButton
          label="Go to next month"
          icon="angle-right"
          onClick={goToNextMonth}
          className={navButtonClass}
        />
        <IconButton
          label="Go to next year"
          icon="angles-right"
          onClick={goToNextYear}
          className={navButtonClass}
        />
      </div>
      <DayPicker
        {...props}
        month={currentMonth}
        hideNavigation={true}
        onMonthChange={handleMonthChange}
      />
    </div>
  );
};

DayPickerCalendar.propTypes = {
  defaultMonth: PropTypes.instanceOf(Date),
  className: PropTypes.string,
};
